<template>
  <div id="app">

    <div class="top-nav">

      <div class="top-nav-item">

        <!-- Partner -->
        <div id="partner" v-if="adminMode">
          <label for="partnerSelect">Partner:</label>
          <select id="partnerSelect" v-model="partner">
            <option v-for="partner in partners" :key="partner.id" :value="partner">{{ partner.name }}</option>
          </select>
          <!-- <pre v-show="debugMode">{{partner}}</pre> -->
        </div>
        <div id="partner" v-else-if="partnerMode">
          Partner: {{ partner.name }}
        </div>


        <!-- Account -->
        <div id="account" v-if="adminMode || partnerMode">
          <label for="accountSelect">Account:</label>
          <select id="accountSelect" v-model="account">
            <option v-for="account in accounts" :key="account.id" :value="account">{{ account.name }}</option>
          </select>
          <!-- <pre v-show="debugMode">{{account}}</pre> -->
        </div>
        <div id="account" v-else>
          Account: {{ account.name }}
        </div>

        <!-- Profile -->
        <div id="profile" v-show="profiles && profiles.length > 1">
          <label for="profileSelect">Profile:</label>
          <select id="profileSelect" v-model="profile">
            <option v-for="profile in profiles" :key="profile.id" :value="profile">{{ profile.name }}</option>
          </select>
          <!-- <pre v-show="debugMode">{{profile}}</pre> -->
        </div>
      </div>

      <!-- Debug mode -->
      <div class="top-nav-item">
        <input type="checkbox" id="debugMode" v-model="debugMode">
        <label for="debugMode">Debug mode</label>
      </div>

      <!-- keycloak logout -->
      <div v-if="userInfo['preferred_username']" class="apiKeyAccount">
          {{ userInfo['preferred_username'] }}
          <div>
            <button @click="logout">Logout</button>
          </div>
        </div>

    </div>

    <router-link class="router-link" to="/">Dashboard</router-link>
    <router-link class="router-link" to="/partners" v-if="adminMode">Partners</router-link>
    <router-link class="router-link" to="/partner" v-if="partnerMode">Partner</router-link>
    <router-link class="router-link" to="/accounts" v-if="adminMode || partnerMode">Accounts</router-link>
    <router-link class="router-link" to="/account" v-if="accountMode">Account</router-link>
    <router-link class="router-link" to="/profiles">Profiles</router-link>
    <router-link class="router-link" to="/keywords">Keywords</router-link>
    <router-link class="router-link" to="/alerts">Alerts</router-link>
    <router-link class="router-link" to="/remediation">Remediation</router-link>
    <router-link class="router-link" to="/settings">Settings</router-link>
    <router-view/>
  </div>
</template>

<style>
select {
  margin-right:5px;
}
label {
  margin-right:5px;
}
pre {
  margin: 0px;
  padding: 5px;
  max-width: 100%;
  color: #333;
  background-color: wheat;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 5px;
}
#partner {
  font-size: 18px;
  margin-right: 20px;
}
#partner > select {
  font-size: 18px;
}
#account {
  font-size: 18px;
  margin-right: 20px;
}
#account > select {
  font-size: 18px;
}
#profile {
  font-size: 18px;
  margin-right: 20px;
}
#profile > select {
  font-size: 18px;
}
.apiKeyAccount {
  margin-left: 5px;
  font-size: 18px;
}
.top-nav {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.top-nav-item {
   display: flex;
   text-align: left;
}
.api-key-input {
  margin-right: 5px;
}
.router-link {
  margin-right: 5px;
}
.router-link-exact-active {
  font-size: 26px;
}
.page {
  margin-top: 20px;
  margin-left: 20%;
  margin-right: 20%;
  text-align: left;
}
.bordered {
  margin-top: 5px;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #cccccc;
}
.debug {
  font-size: 10px;
  background-color: white !important;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',
  computed: {
    debugMode: {
      get(){return this.$store.state.debugMode},
      set(val){this.$store.commit('setDebugMode', val)}
    },
    partner: {
      get(){return this.$store.state.partner},
      set(val){this.$store.dispatch('selectPartner', val)}
    },
    account: {
      get(){return this.$store.state.account},
      set(val){this.$store.dispatch('selectAccount', val)}
    },
    profile: {
      get(){return this.$store.state.profile},
      set(val){this.$store.dispatch('selectProfile', val)}
    },
    ...mapState([
      'adminMode',
      'partnerMode',
      'accountMode',
      'partners',
      'accounts',
      'profiles',
      'userInfo'
    ])
  },
  methods: {
    logout(){
      if (this.$keycloak)
        this.$keycloak.logout()
    },
  },
  data () {
    return {
      accessToken: localStorage.getItem('accessToken'),
    }
  },
}
</script>
